export const optionsForBookingStatus: Array<string> = [
  'waiting',
  'offered',
  'confirmed',
  'started',
  'finished',
  'cancelled',
];
